export default __webpack_public_path__ + "static/media/maharajaSpicesGrill.4267739d.png";